<template>
  <div class="ui container view">
    <div class="ui raised clearing segment component" v-for="component in quote.components">
      <a class="delete control" @click.prevent="confirmComponentRemoval(component)" href="#" title="Delete Component">
        <i class="large red remove link icon"></i>
      </a>
      <a  class="reorder control" @click.prevent="reorder({ target: 'sections', title: component.title, items: component.sections })" href="#" title="Reorder Sections">
        <i class="large sort link icon"></i>
      </a>
      <h2>
        <span class="ui big blue circular label">{{ component.hours }}</span>
        <div class="ui transparent input">
          <input v-model="component.title" @change="updateQuote" type="text">
        </div>
      </h2>
      <table class="section ui celled table" v-for="section in component.sections">
        <thead>
          <tr>
            <th class="title" colspan="2">
              <div class="ui transparent input">
                <input v-model="section.title" @change="updateQuote" type="text">
              </div>
            </th>
            <th class="controls">
              <a @click.prevent="reorder({ target: 'items', title: section.title, items: section.items })" href="#" title="Reorder Items">
                <i class="sort link icon"></i>
              </a>
            </th>
            <th class="controls">
              <a @click.prevent="confirmSectionRemoval(component, section)" href="#" title="Delete Section">
                <i class="red remove link icon"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="item" v-for="item in section.items">
            <td class="description">
              <div class="ui transparent input">
                <input v-model="item.title" @change="updateQuote" type="text">
              </div>
            </td>
            <td class="type">
              <select v-model="item.type" @change="updateQuote" class="ui fluid dropdown">
                <option v-for="itemType in itemTypes" v-bind:value="itemType.value">
                  {{ itemType.abbr }}
                </option>
              </select>
            </td>
            <td class="hours">
              <div class="ui transparent input">
                <input v-model.number="item.hours" @change="calcSectionHours(component, section)" type="text">
              </div>
            </td>
            <td class="controls">
              <a @click.prevent="confirmItemRemoval(component, section, item)" href="#" title="Delete Item">
                <i class="red remove link icon"></i>
              </a>
            </td>
          </tr>
          <tr>
            <td class="description" colspan="2"></td>
            <td class="hours"><strong>{{ section.hours }}</strong></td>
            <td class="controls">
              <a @click.prevent="addItem(section)" href="#" title="Add Item">
                <i class="green plus link icon"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="mini ui green right floated labeled icon button" @click="addSection(component)">
        <i class="plus icon"></i>
        SECTION
      </button>
    </div>
    <button class="mini ui blue labeled icon button" @click="reorder({ target: 'components', title: 'Quote', items: quote.components })" title="Reorder Components">
      <i class="sort icon"></i>
      COMPONENTS
    </button>
    <button class="mini ui blue labeled icon button" @click="addComponent" title="Add Component">
      <i class="plus icon"></i>
      COMPONENT
    </button>
    <modal-confirm :payload="confirmPayload" v-on:confirm="remove" />
    <modal-reorder :payload="reorderPayload" v-on:reorder="updateQuote" v-on:close="reorderCleanup" />
  </div>
</template>

<script>
import ModalConfirm from './ModalConfirm.vue'
import ModalReorder from './ModalReorder.vue'

export default {
  data () {
    return {
      quote: {},
      confirmPayload: {},
      reorderPayload: {}
    }
  },

  components: {
    ModalConfirm,
    ModalReorder
  },

  computed: {
    quoteIsLoaded () {
      return this.$store.getters.quoteIsLoaded
    },

    itemTypes () {
      return this.$store.getters.itemTypes
    }
  },

  methods: {
    updateQuote () {
      this.$store.commit('UPDATE_QUOTE', { payload: JSON.stringify(this.quote) })
    },

    addComponent () {
      var newComponent = { title: 'New Component', hours: 0, sections: [] }
      this.addSection(newComponent)
      this.quote.components.push(newComponent)
      this.updateQuote()
    },

    addSection (component) {
      var newSection = { title: 'New Section', hours: 0, items: [] }
      this.addItem(newSection)
      component.sections.push(newSection)
      this.updateQuote()
    },

    addItem (section) {
      var newItem = { title: 'New Item', type: 'des', hours: 0 }
      section.items.push(newItem)
      this.updateQuote()
    },

    confirmComponentRemoval (component) {
      this.confirmPayload = {
        message: `Are you sure you want to remove the <strong>${component.title}</strong> component and all it's contents?`,
        target: 'component',
        component: component
      }
      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show')
    },

    confirmSectionRemoval (component, section) {
      this.confirmPayload = {
        message: `Are you sure you want to remove the <strong>${section.title}</strong> section and all it's contents from the <strong>${component.title}</strong> component?`,
        target: 'section',
        component: component,
        section: section
      }
      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show')
    },

    confirmItemRemoval (component, section, item) {
      this.confirmPayload = {
        message: `Are you sure you want to remove the <strong>${item.title}</strong> item?`,
        target: 'item',
        component: component,
        section: section,
        item: item
      }
      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show')
    },

    remove (confirmed) {
      if (confirmed) {
        var payload = this.confirmPayload
        switch (payload.target) {
          case 'component': {
            let component = payload.component
            let index = this.quote.components.indexOf(component)
            this.quote.components.splice(index, 1)
            this.calcQuoteHours()
            break
          }
          case 'section': {
            let component = payload.component
            let section = payload.section
            let index = component.sections.indexOf(section)
            component.sections.splice(index, 1)
            this.calcComponentHours(component)
            break
          }
          case 'item': {
            let component = payload.component
            let section = payload.section
            let item = payload.item
            let index = section.items.indexOf(item)
            section.items.splice(index, 1)
            this.calcSectionHours(component, section)
            break
          }
        }
        this.updateQuote()
      } else {
        this.confirmPayload = {}
      }
    },

    reorder (options) {
      this.reorderPayload = options
      window.$('#modal-reorder').modal('setting', 'closable', false).modal('show')
    },

    reorderCleanup () {
      this.reorderPayload = {}
    },

    calcSectionHours (component, section) {
      let total = 0
      section.items.forEach(function (item) {
        let hours = isNaN(parseInt(item.hours)) ? 0 : parseInt(item.hours)
        total += hours
      })
      section.hours = total
      this.calcComponentHours(component)
    },

    calcComponentHours (component) {
      let total = 0
      component.sections.forEach(function (section) {
        total += parseInt(section.hours)
      })
      component.hours = total
      this.calcQuoteHours()
    },

    calcQuoteHours () {
      let total = 0
      this.quote.components.forEach(function (component) {
        total += parseInt(component.hours)
      })
      this.quote.hours = total
      this.updateQuote()
    }
  },

  created () {
    if (this.$store.getters.quoteIsLoaded) {
      this.quote = JSON.parse(this.$store.getters.loadQuote)
    } else {
      console.log('Quote not yet loaded. Redirecting...')
      this.$router.replace({ name: 'new' })
    }
    console.log('Quote is new: ' + this.$store.getters.isNewQuote)
  },

  mounted () {
    window.$('select.ui.dropdown').dropdown()
  },

  updated () {
    window.$('select.ui.dropdown').dropdown()
  },

  destroyed () {
    window.$('.ui.dimmer.modals.page.transition.hidden').remove()
  }
}
</script>

<style lang="scss" scoped>
  .ui.transparent.input {
    input:hover,
    input:focus {
      background-color: #eee !important;
    }
  }

  .component {
    h2 {
      margin-top: .2em;
      margin-bottom: 1em;

      .ui.transparent.input {
        width: 90%;
      }
    }

    a.reorder.control,
    a.delete.control {
      display: inline-block;
      float: right;
    }
  }

  .ui.table tr {
    td.controls,
    th.controls {
      text-align: center;
      width: 5%;
    }

    th.title .ui.transparent.input {
      font-weight: bold;
      width: 50%;
    }

    td {
      &.description {
        width: 90%;

        .ui.transparent.input {
          width: 100%;
        }
      }

      &.type {
        text-align: center;
        width: 10%;
      }

      &.hours {
        text-align: center;
        width: 5%;

        input {
          text-align: center;
          width: 2em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Editor.vue?2c24ccbe